/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello ",
  hand: "👋",
  title2: "Ramaditya",
  logo_name: "RAMADITYA",
  nickname: "Ramaditya",
  full_name: "Ramaditya Chaudhary",
  subTitle: "Full-Stack Developer, Open Source Enthusiast 🔥. Always learning.",
  resumeLink:
    "https://drive.google.com/file/d/1RO1vBOrzXCstWf7y-cMrbP_J0xTmt9_u/view?usp=sharing",
  mail: "mailto:ramadityachaudhary@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/ramaditya57",
  linkedin: "https://www.linkedin.com/in/ramaditya-chaudhary-287b36251",
  gmail: "ramadityachaudhary@gmail.com",
  // gitlab: "https://gitlab.com/ramaditya",
  // facebook: "https://www.facebook.com/ramaditya/",
  // twitter: "https://twitter.com/ramaditya",
  // instagram: "https://www.instagram.com/ramaditya/",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications",
        "⚡ Building responsive website front end using ReactJS",
        "⚡ Creating application backend in Node, Express & Flask",
        "⚡ Integration of third party services such as Firebase/ MongoDB",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "simple-icons:css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "devicon-plain:java-wordmark",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
      ],
    },
    // {
    //   title: "Cloud Infra-Architecture",
    //   fileName: "CloudInfraImg",
    //   skills: [
    //     "⚡ Experience working on multiple cloud platforms",
    //     "⚡ Experience hosting and managing websites",
    //     "⚡ Experience with Continuous Integration",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "AWS",
    //       fontAwesomeClassname: "simple-icons:amazonaws",
    //       style: {
    //         color: "#FF9900",
    //       },
    //     },
    //     {
    //       skillName: "Netlify",
    //       fontAwesomeClassname: "simple-icons:netlify",
    //       style: {
    //         color: "#38AFBB",
    //       },
    //     },
    //     {
    //       skillName: "Heroku",
    //       fontAwesomeClassname: "simple-icons:heroku",
    //       style: {
    //         color: "#6863A6",
    //       },
    //     },
    //     {
    //       skillName: "Firebase",
    //       fontAwesomeClassname: "simple-icons:firebase",
    //       style: {
    //         color: "#FFCA28",
    //       },
    //     },
    //     {
    //       skillName: "PostgreSQL",
    //       fontAwesomeClassname: "simple-icons:postgresql",
    //       style: {
    //         color: "#336791",
    //       },
    //     },
    //     {
    //       skillName: "MongoDB",
    //       fontAwesomeClassname: "simple-icons:mongodb",
    //       style: {
    //         color: "#47A248",
    //       },
    //     },
    //     {
    //       skillName: "Docker",
    //       fontAwesomeClassname: "simple-icons:docker",
    //       style: {
    //         color: "#1488C6",
    //       },
    //     },
    //     {
    //       skillName: "GitHub Actions",
    //       fontAwesomeClassname: "simple-icons:githubactions",
    //       style: {
    //         color: "#5b77ef",
    //       },
    //     },
    //   ],
    // },
    {
      title: "Machine Learning",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Built and trained various supervised and unsupervised ML models",
        "⚡ Hands-on experience with Scikit-learn, TensorFlow, and PyTorch",
        "⚡ Worked on real-world datasets for predictions and classifications",
        "⚡ Built recommendation systems and sentiment analysis tools",
      ],
      softwareSkills: [
        {
          skillName: "Scikit-learn",
          fontAwesomeClassname: "simple-icons:scikitlearn",
          style: {
            color: "#F7931E",
          },
        },
        {
          skillName: "TensorFlow",
          fontAwesomeClassname: "simple-icons:tensorflow",
          style: {
            color: "#FF6F00",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "simple-icons:pytorch",
          style: {
            color: "#EE4C2C",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            color: "#150458",
          },
        },
        {
          skillName: "NumPy",
          fontAwesomeClassname: "simple-icons:numpy",
          style: {
            color: "#013243",
          },
        },
        {
          skillName: "Jupyter",
          fontAwesomeClassname: "simple-icons:jupyter",
          style: {
            color: "#F37626",
          },
        },
        {
          skillName: "Matplotlib",
          fontAwesomeClassname: "simple-icons:matplotlib",
          style: {
            color: "#11557C",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
        {
          skillName: "Inkscape",
          fontAwesomeClassname: "simple-icons:inkscape",
          style: {
            color: "#000000",
          },
        },
      ],
    },
  ],
};

// const competitiveSites = {
//   competitiveSites: [
//     {
//       siteName: "LeetCode",
//       iconifyClassname: "simple-icons:leetcode",
//       style: {
//         color: "#F79F1B",
//       },
//       profileLink: "https://leetcode.com/layman_brother/",
//     },
//     {
//       siteName: "HackerRank",
//       iconifyClassname: "simple-icons:hackerrank",
//       style: {
//         color: "#2EC866",
//       },
//       profileLink: "https://www.hackerrank.com/layman_brother",
//     },
//     {
//       siteName: "Codechef",
//       iconifyClassname: "simple-icons:codechef",
//       style: {
//         color: "#5B4638",
//       },
//       profileLink: "https://www.codechef.com/users/ashutosh_1919",
//     },
//     {
//       siteName: "Codeforces",
//       iconifyClassname: "simple-icons:codeforces",
//       style: {
//         color: "#1F8ACB",
//       },
//       profileLink: "http://codeforces.com/profile/layman_brother",
//     },
//     {
//       siteName: "Hackerearth",
//       iconifyClassname: "simple-icons:hackerearth",
//       style: {
//         color: "#323754",
//       },
//       profileLink: "https://www.hackerearth.com/@ashutosh391",
//     },
//   ],
// };

const degrees = {
  degrees: [
    {
      title: "Vellore Institute Of Technology",
      subtitle: "Bachelor in Technology",
      logo_path: "ssec.png",
      alt_name: "VIT",
      duration: "2022 - 2026",
      descriptions: [
        "⚡ I have studied core subjects like Machine Learning, Computer Vision, Advanced Web Development.",
        "⚡ I have implemented several projects based on what I've leart under my Computer Engineering course. ",
        "⚡ I participated in many hackathons.",
      ],
      website_link: "https://vitbhopal.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    // {
    //   title: "M0001: MongoDB Basics",
    //   subtitle: "MongoDB University",
    //   logo_path: "mongo.png",
    //   certificate_link:
    //     "https://drive.google.com/file/d/12se6bMep48WXA1PlizTBAgCnW0GXM6wq/view?usp=sharing",
    //   alt_name: "MongoDB University",
    //   // color_code: "#2AAFED",
    //   color_code: "#47A048",
    // },
    {
      title: "Full Stack MERN",
      subtitle: "MERN",
      logo_path: "mern.png",
      certificate_link:
        "https://skillwallet.smartinternz.com/internships/mongo_db/ca0525bfe5cab4c577d169d3343a5452",
      alt_name: "MERN Stack",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    {
      title: "Postman Student API Expert",
      subtitle: "Postman",
      logo_path: "postman.png",
      certificate_link:
        "https://badgr.com/public/assertions/zv0zBTsQRueN1uAMKVrFMg?identity__email=ramadityachaudhary@gmail.com",
      alt_name: "Postman",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    {
      title: "Gen AI Using IBM Watsonx",
      subtitle: "Gen AI",
      logo_path: "genai.jpg",
      certificate_link:
        "https://courses.ibmcep.cognitiveclass.ai/certificates/704a6a0b26a54d0d829cbe03900680b0",
      alt_name: "Gen AI",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    {
      title: "MATLAB Onramp",
      subtitle: "Matlab Onramp",
      logo_path: "mathworks.png",
      certificate_link:
        "https://matlabacademy.mathworks.com/progress/share/certificate.html?id=bc59e67e-8b18-463f-a056-d42ca648030c&",
      alt_name: "Matlab Onramp",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    {
      title: "Simulink Onramp",
      subtitle: "Simulink Onramp",
      logo_path: "mathworks.png",
      certificate_link:
        "https://matlabacademy.mathworks.com/progress/share/certificate.html?id=ef062f8c-9122-44a8-a07f-d666659d5063&",
      alt_name: "Simulink Onramp",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    {
      title: "Data Structures and Algorithms",
      subtitle: "Data Structures and Algorithms",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/d7e358e6b34a4da4babda5eebcc3703ee6a22545b98d6628d9cd905c9aea45ab?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BeghXrKPUTxy7jSl3oPfUaQ%3D%3D",
      alt_name: "DSA",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    {
      title: "Cloud Computing",
      subtitle: "Cloud Computing",
      logo_path: "nptel.jpg",
      certificate_link:
        "https://archive.nptel.ac.in/content/noc/NOC24/SEM1/Ecertificates/106/noc24-cs17/Course/NPTEL24CS17S35290012230657720.pdf",
      alt_name: "Cloud Computing",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    {
      title: "Bits and Bytes of Computer Networking",
      subtitle: "Computer Networking",
      logo_path: "Google.png",
      certificate_link:
        "https://coursera.org/share/53d74972937c9e69ba0c8c4a18e0b226",
      alt_name: "Computer Networking",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    {
      title: "Marketing Analysis",
      subtitle: "Marketing Analysis",
      logo_path: "nptel.jpg",
      certificate_link:
        "https://drive.google.com/file/d/17BG8I5px4HA0GIpbhjmMBQrJdDctJxng/view?usp=sharing",
      alt_name: "Marketing Analysis",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    // color_code: "#8C151599",
    // color_code: "#7A7A7A",
    // color_code: "#0C9D5899",
    // color_code: "#C5E2EE",
    // color_code: "#ffc475",
    // color_code: "#g",
    // color_code: "#ffbfae",
    // color_code: "#fffbf3",
    // color_code: "#b190b0",
  ],
};

export const skillsData = [
  {
    id: 1,
    name: "JavaScript",
    iconifyClassname: "simple-icons:javascript",
    category: "Frontend",
    description:
      "Modern JS including ES6+, async/await, and functional programming concepts",
    proficiency: 75,
  },
  {
    id: 2,
    name: "React",
    iconifyClassname: "simple-icons:react",
    category: "Frontend",
    description:
      "Building complex UIs with hooks, context API and state management",
    proficiency: 60,
  },
  {
    id: 3,
    name: "CSS/SASS",
    iconifyClassname: "fa-css3",
    category: "Frontend",
    description:
      "Advanced styling with flexbox, grid, animations, and responsive design",
    proficiency: 80,
  },
  {
    id: 4,
    name: "Tailwind CSS",
    iconifyClassname: "simple-icons:tailwindcss",
    category: "Frontend",
    description:
      "Utility-first CSS framework for rapidly building custom designs",
    proficiency: 80,
  },
  {
    id: 5,
    name: "TypeScript",
    iconifyClassname: "simple-icons:typescript",
    category: "Frontend",
    description:
      "Type-safe JavaScript with interfaces, generics, and utility types",
    proficiency: 75,
  },
  {
    id: 6,
    name: "Node.js",
    iconifyClassname: "simple-icons:nodedotjs",
    category: "Backend",
    description:
      "Server-side JavaScript runtime for building scalable network applications",
    proficiency: 40,
  },
  {
    id: 7,
    name: "Express",
    iconifyClassname: "simple-icons:express",
    category: "Backend",
    description: "Fast, unopinionated, minimalist web framework for Node.js",
    proficiency: 45,
  },
  {
    id: 8,
    name: "MongoDB",
    iconifyClassname: "simple-icons:mongodb",
    category: "Database",
    description: "Document-based NoSQL database for modern applications",
    proficiency: 45,
  },
  {
    id: 11,
    name: "Docker",
    iconifyClassname: "simple-icons:docker",
    category: "DevOps",
    description:
      "Containerization platform for building, shipping, and running applications",
    proficiency: 50,
  },
  {
    id: 12,
    name: "AWS",
    iconifyClassname: "simple-icons:amazonaws",
    category: "DevOps",
    description: "Cloud services including EC2, S3, Lambda, and more",
    proficiency: 45,
  },
  {
    id: 13,
    name: "Git",
    iconifyClassname: "simple-icons:git",
    category: "Tools",
    description:
      "Version control system for tracking changes and collaborating",
    proficiency: 85,
  },
  {
    id: 15,
    name: "Figma",
    iconifyClassname: "simple-icons:figma",
    category: "Design",
    description:
      "Collaborative UI design tool for creating, testing, and shipping designs",
    proficiency: 85,
  },
  {
    id: 16,
    name: "Python",
    iconifyClassname: "simple-icons:python",
    category: "Backend",
    description:
      "General-purpose programming language with focus on readability",
    proficiency: 75,
  },
  {
    id: 17,
    name: "Redux",
    iconifyClassname: "simple-icons:redux",
    category: "Frontend",
    description: "Predictable state container for JavaScript apps",
    proficiency: 80,
  },
  {
    id: 18,
    name: "Next.js",
    iconifyClassname: "simple-icons:nextdotjs",
    category: "Frontend",
    description:
      "React framework for production with server-side rendering and static generation",
    proficiency: 75,
  },
  {
    id: 19,
    name: "Flask",
    iconifyClassname: "simple-icons:flask",
    category: "Backend",
    description:
      "Lightweight and flexible Python web framework for building simple to complex web applications with ease",
    proficiency: 85,
  },
  {
    id: 20,
    name: "Canva",
    iconifyClassname: "simple-icons:canva",
    category: "Design",
    description:
      "Collaborative UI design tool for creating, testing, and shipping designs",
    proficiency: 85,
  },
  {
    id: 21,
    name: "Selenium",
    iconifyClassname: "simple-icons:selenium",
    category: "Testing",
    description: "Open-source framework used for automating web browsers",
    proficiency: 55,
  },
  {
    id: 22,
    name: "Java",
    iconifyClassname: "devicon-plain:java-wordmark",
    category: "Backend",
    description:
      "Versatile, Object-oriented programming language known for its platform independence",
    proficiency: 85,
  },
  {
    id: 23,
    name: "C++",
    iconifyClassname: "simple-icons:cplusplus",
    category: "Backend",
    description:
      "Powerful, general-purpose programming language that extends the C language with object-oriented features",
    proficiency: 75,
  },
  {
    id: 24,
    name: "Bootstrap",
    iconifyClassname: "simple-icons:bootstrap",
    category: "Frontend",
    description:
      "Open-source CSS framework for designing responsive and mobile-first websites with pre-built components and layouts",
    proficiency: 85,
  },
  {
    id: 25,
    name: "MySQL",
    iconifyClassname: "simple-icons:mysql",
    category: "Database",
    description:
      "Open-source relational database management system (RDBMS) used for efficiently storing, retrieving, and managing structured data",
    proficiency: 85,
  },
  {
    id: 26,
    name: "Beautiful Soup",
    iconifyClassname: "simple-icons:python",
    category: "Backend",
    description:
      "Python library for easily parsing HTML and XML documents to extract data from web pages",
    proficiency: 85,
  },
  {
    id: 27,
    name: "Postman API",
    iconifyClassname: "simple-icons:postman",
    category: "API",
    description: "Platform for building, testing, and managing APIs",
    proficiency: 45,
  },
];

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "As a Full Stack Developer, I have worked with projects for over two years. I've mostly done projects on my own.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Full Stack Web Developer Intern",
          company: "Smartbridge",
          // company_url: "https://www.crestinfosystems.com/",
          logo_path: "smartbridge.png",
          duration: "Jan 2025 - Mar 2025",
          location: "Remote",
          description: `Contributed to the design and development of a full-stack food ordering platform by building responsive, role-based interfaces for customers, administrators, and restaurant partners. Collaborated with cross-functional team members to implement dynamic cart functionality, order management workflows, and secure authentication mechanisms. Improved application scalability and usability by following modular architecture and best coding practices. Focused on delivering intuitive, user-centric experiences aligned with business requirements and real-world food ordering workflows.`,
          color: "#0071C5",
        },
        {
          title: "Front End Web Developer Intern",
          company: "Dr. Ambedkar Lab Foundation",
          // company_url: "https://www.crestinfosystems.com/",
          logo_path: "ambedkarlabfoundation.jpeg",
          duration: "Nov 2023 - Jan 2024",
          location: "Remote",
          description: `Contributed to enhancing web performance and user engagement by optimizing front-end applications and improving site responsiveness. Collaborated with cross-functional teams during bi-weekly feedback sessions to accelerate development cycles and improve overall productivity. Ensured robust data protection by implementing secure coding practices and maintaining high availability. Focused on delivering user-centric interfaces that aligned with the organization’s goals and elevated the overall user experience.`,
          color: "#0071C5",
        },
        //         {
        //           title: "Software Engineer",
        //           company: "Crest Infosystems Pvt. Ltd.",
        //           company_url: "https://www.crestinfosystems.com/",
        //           logo_path: "crest.png",
        //           duration: "Jan 2024 - Present",
        //           location: "Surat, Gujarat",
        //           description: `Worked on enterprise-level software solutions including employee
        // activity tracking system, point of sale system and support ticket
        // systems, utilizing full-stack technologies and custom integrations. Improved system efficiency and user experience across
        // multiple projects by developing and maintaining full-stack web apps
        // with modern technologies like Electron.js, React.js, Node.js, and
        // Sequelize. Designed and implemented custom solutions for tracking employee
        // activity and database optimizations, resulting in improvement in
        // performance.`,
        //           color: "#0071C5",
        //         },
        // {
        //   title: "Node.js Backend Developer",
        //   company: "Valora Infotech",
        //   company_url: "http://valorainfotech.com/",
        //   logo_path: "valora.jpg",
        //   duration: "Oct 2020 - Dec 2022",
        //   location: "Surat, Gujarat",
        //   description: `Train, oversee, and mentor young software development employees. I created and managed the admin panel backend and a gambling application as a Node.js backend developer. I obtained knowledge in Web Socket, Payment Gateway Integration, and gaming legislation, while growing my industry experience and investigating new technologies.
        //   Focus on change request functions in close collaboration with the project manager and team leads.
        //   Developed new and maintained existing applications.
        //   Increased productivity and problem-solving technics by 20%.
        //   We primarily used PERN and MERN Stack. 80% of my work was doing backend development and the remaining 20% was DevOps-related tasks.
        //   `,
        //   // "I worked on the Dashboard project which helps users track their activities while using Walo Application. I also worked on Ocean Inventory Application and it's Admin panel Backend as well as on Ocean Inventory Admin Front-end using React and also worked on Walo Admin Backend.",
        //   color: "#0071C5",
        // },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Technical Team Member",
          company: "VITronix Club, VIT Bhopal",
          // company_url: "https://bauddhikgeeks.tech/",
          logo_path: "vitronix.png",
          duration: "July 2024 - Present",
          location: "On Campus",
          description:
            "Volunteered during the “Electro-Craft” workshop organized by the VITronix Club in collaboration with Hyaku Innovative Technologies Pvt. Ltd. at VIT-Bhopal. Actively contributed to supporting participants in exploring electronics and programming concepts, enabling them to gain practical exposure to the technical domain. Assisted in managing event logistics and mentoring attendees, ensuring a productive learning environment. The experience fostered technical growth, teamwork, and knowledge sharing, while promoting community-driven skill development.",
          color: "#FBBD18",
        },
        // {
        //   title: "Campus Hustler",
        //   company: "Skillenza",
        //   company_url: "https://skillenza.com/",
        //   logo_path: "skillenza.png",
        //   duration: "Feb 2021 - Present",
        //   location: "Work from Home",
        //   description:
        //     "Spread Awareness of new Technologies and new Opportunities to Students and Grow Skillenza Community.",
        //   color: "#196acf",
        // },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of latest technology tools. My best experience is to create Python Scripts, and React Project. Below are some of my projects.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "ram-crop.png",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    // title: "Blogs",
    // subtitle:
    // "I don't blog frequently but when I do something awesome, I do try to document it so it can be helpful to others. I write on Twitter.",
    // link: "https://twitter.com/Harikrushn9",
    // avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    // {
    //   id: "0",
    //   name: "FoodRescue",
    //   url: "https://github.com/ramaditya57/Food-Rescue",
    //   description:
    //     "FoodRescue is a full-stack food donation and redistribution platform built to combat food waste and hunger.",
    //   languages: [
    //     {
    //       name: "React",
    //       iconifyClass: "logos-react",
    //     },
    //     {
    //       name: "Node.js",
    //       iconifyClass: "logos-nodejs",
    //     },
    //     {
    //       name: "Express.js",
    //       iconifyClass: "simple-icons:express",
    //     },
    //     {
    //       name: "MongoDB",
    //       iconifyClass: "logos-mongodb",
    //     },
    //     {
    //       name: "Tailwind CSS",
    //       iconifyClass: "logos-tailwindcss-icon",
    //     },
    //     {
    //       name: "Razorpay",
    //       iconifyClass: "simple-icons:razorpay",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "https://github.com/ramaditya57/Food-Rescue",
    //       iconifyClass: "ri:github-fill",
    //     },
    //     {
    //       name: "Live Demo",
    //       url: "https://food-rescue-project.vercel.app/",
    //       iconifyClass: "mdi:web",
    //     },
    //   ],
    // },
    {
      id: "1",
      name: "CareCloud",
      url: "https://github.com/ramaditya57/CareCloud",
      description:
        "A comprehensive Hospital Management System built on the MERN stack to streamline healthcare operations.",
      languages: [
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "Node.js",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "Express.js",
          iconifyClass: "simple-icons:express",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
        {
          name: "Redux",
          iconifyClass: "logos-redux",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/ramaditya57/CareCloud",
          iconifyClass: "ri:github-fill",
        },
        {
          name: "Live Demo",
          url: "https://care-cloud.vercel.app/",
          iconifyClass: "mdi:web",
        },
      ],
    },
    {
      id: "3",
      name: "SB Foods – Food Ordering App",
      url: "https://github.com/ramaditya57/SB-Foods",
      description:
        "A scalable MERN food ordering platform featuring role-based access and real-time order management.",
      languages: [
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "Node.js",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "Express.js",
          iconifyClass: "simple-icons:express",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
        {
          name: "REST API",
          iconifyClass: "mdi:api",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/ramaditya57/SB-Foods",
          iconifyClass: "ri:github-fill",
        },
        {
          name: "Live Demo",
          url: "https://sb-foods-fooddelivery.vercel.app/",
          iconifyClass: "mdi:web",
        },
      ],
    },
    {
      id: "4",
      name: "Task Flow – Task Manager App",
      url: "https://github.com/ramaditya57/Task-Manager",
      description:
        "A MERN-based task management application for tracking tasks, priorities, and team collaboration with productivity insights.",
      languages: [
        {
          name: "React.js",
          iconifyClass: "logos-react",
        },
        {
          name: "Node.js",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "Express.js",
          iconifyClass: "simple-icons:express",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/ramaditya57/Task-Manager",
          iconifyClass: "ri:github-fill",
        },
        {
          name: "Live Demo",
          url: "https://taskflow-task-manager.vercel.app/",
          iconifyClass: "mdi:web",
        },
      ],
    },
    {
      id: "7",
      name: "Farmify",
      url: "https://github.com/ramaditya57/Farmify-Project",
      description:
        "Farmify is an AI-powered precision agriculture platform that provides crop recommendations and plant disease detection.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Machine Learning",
          iconifyClass: "mdi:brain",
        },
        {
          name: "Deep Learning (CNN)",
          iconifyClass: "simple-icons:tensorflow",
        },
        {
          name: "Flask",
          iconifyClass: "simple-icons:flask",
        },
        {
          name: "YOLOv8",
          iconifyClass: "simple-icons:opencv",
        },
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
        {
          name: "CSS3",
          iconifyClass: "logos-css-3",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/ramaditya57/Farmify-Project",
          iconifyClass: "ri:github-fill",
        },
        {
          name: "Live Demo",
          url: "https://farmify-project.onrender.com/",
          iconifyClass: "mdi:web",
        },
      ],
    },
    // {
    //   id: "2",
    //   name: "Drive Mad – WebAssembly Build",
    //   url: "https://github.com/ramaditya57/Car-Game",
    //   description:
    //     "A browser-based game built with WebAssembly and Emscripten, featuring WebGL rendering and seamless JavaScript ↔ WASM integration.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "logos-html-5",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "logos-css-3",
    //     },
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "https://github.com/ramaditya57/Car-Game",
    //       iconifyClass: "ri:github-fill",
    //     },
    //     {
    //       name: "Live Demo",
    //       url: "https://ramaditya-cargame-original.vercel.app/",
    //       iconifyClass: "mdi:web",
    //     },
    //   ],
    // },
    {
      id: "5",
      name: "Rock Paper Scissors Game",
      url: "https://github.com/ramaditya57/Rock-Paper-Scissor",
      description:
        "A simple and interactive Rock Paper Scissors game built using HTML, CSS, and JavaScript, allowing users to play against the computer with real-time score tracking.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
        {
          name: "CSS3",
          iconifyClass: "logos-css-3",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/ramaditya57/Rock-Paper-Scissor",
          iconifyClass: "ri:github-fill",
        },
        {
          name: "Live Demo",
          url: "https://ramaditya57.github.io/Rock-Paper-Scissor/",
          iconifyClass: "mdi:web",
        },
      ],
    },
    // {
    //   id: "6",
    //   name: "SliceIt – Food Ordering SPA",
    //   url: "https://github.com/ramaditya57/SliceIt",
    //   description:
    //     "A client-side food ordering Single Page Application built with React, featuring menu browsing, cart management, and checkout simulation using centralized state management.",
    //   languages: [
    //     {
    //       name: "React",
    //       iconifyClass: "logos-react",
    //     },
    //     {
    //       name: "Vite",
    //       iconifyClass: "logos-vitejs",
    //     },
    //     {
    //       name: "CSS",
    //       iconifyClass: "logos-css-3",
    //     },
    //   ],
    //   links: [
    //     {
    //       name: "Github",
    //       url: "https://github.com/ramaditya57/SliceIt",
    //       iconifyClass: "ri:github-fill",
    //     },
    //     {
    //       name: "Live Demo",
    //       url: "https://ramaditya57.github.io/SliceIt",
    //       iconifyClass: "mdi:web",
    //     },
    //   ],
    // },
    {
      id: "8",
      name: "Dice Game – React SPA",
      url: "https://github.com/ramaditya57/Dice-Game",
      description:
        "A client-side React SPA that simulates a dice-based logic game, demonstrating state management and pseudo-random number generation without any backend dependencies.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "JavaScript (ESNext)",
          iconifyClass: "logos-javascript",
        },
        {
          name: "Vite",
          iconifyClass: "logos-vitejs",
        },
        {
          name: "CSS Modules",
          iconifyClass: "logos-css-3",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/ramaditya57/Dice-Game",
          iconifyClass: "ri:github-fill",
        },
        {
          name: "Live Demo",
          url: "https://ramaditya57.github.io/Dice-Game/",
          iconifyClass: "mdi:web",
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
